<template>
	<div>
		<div class="page-header-intersector" v-intersect="onIntersect"></div>
		<heading
				v-if="!isIntersecting"
				v-bind="{
					backUrl,
					description,
					fluid,
					title,
					status,
					statusColor,
					subTitle
				}"
				fixed
				:is-editing="isEditing"
		>
			<template v-slot:default>
				<slot name="default"></slot>
			</template>
			<template v-slot:actions>
				<slot name="actions"></slot>
			</template>
		</heading>
		<heading
				v-bind="{
					backUrl,
					description,
					fluid,
					title,
					status,
					statusColor,
					subTitle
				}"
				:is-editing="isEditing"
		>
			<template v-slot:default>
				<slot name="default"></slot>
			</template>
			<template v-slot:actions v-if="isIntersecting">
				<slot name="actions"></slot>
			</template>
		</heading>
	</div>
</template>

<script>
import Heading from './components/Heading';

export default {
	inheritAttrs: false,
	name: 'PageHeaderContainer',
	components: { Heading },
	props: {
		backUrl: {
			type: String,
			default: ''
		},
		description: [String, Boolean],
		fluid: Boolean,
		title: {
			type: String,
			default: 'Oops! You Forgot Your Page Title'
		},
		isEditing: {
			type: Boolean,
			default: true
		},
		status: {
			type: String,
			default: ''
		},
		statusColor: {
			type: String,
			default: 'white'
		},
		subTitle: [String, Boolean]
	},
	data() {
		return {
			isIntersecting: undefined
		};
	},
	methods: {
		onIntersect(entries, observer, isIntersecting) {
			this.isIntersecting = isIntersecting;
		}
	}
};
</script>

<style lang="scss" scoped>
.page-header-intersector {
	position: relative;
	top: 1rem;
}
</style>